
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import IconSearchEmployee from "@/components/common/icon/IconSearchEmployee.vue";
import IconOrders from "@/components/common/icon/IconOrders.vue";
import IconUsers from "@/components/common/icon/IconUsers.vue";
import { mapGetters } from "vuex";
import IconAdministration from "@/components/common/icon/IconAdministration.vue";
import IconDisclaimer from "@/components/common/icon/IconDisclaimer.vue";
import IconReport from "@/components/common/icon/IconReports.vue";
import IconDeposit from "@/components/common/icon/IconDeposit.vue";
import IconApprovals from "@/components/common/icon/IconApprovals.vue";

@Component({
  name: "sidebar",
  computed: {
    ...mapGetters(["getSignedIn"]),
  },
  components: {
    IconDeposit,
    IconDisclaimer,
    IconSearchEmployee,
    IconOrders,
    IconUsers,
    IconAdministration,
    IconReport,
    IconApprovals,
  },
})
export default class Sidebar extends Vue {
  @Getter("getCurrentLocation") getCurrentLocation!: string;
  @Getter("getDisclaimer") getDisclaimer!: string;

  public activeLinkColor = "#FFD102";
  public inactiveLinkColor = "#4C4C4C";

  get currentPath(): string {
    return new URL(this.getCurrentLocation).pathname;
  }

  constructor() {
    super();
  }
}
